import * as React from "react";
import { TextInput, Button, Grid, Title, Card, Text, useMantineTheme } from "@mantine/core";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { ReconsetType } from "@supportinitiative/common";

import { escapeRegExp, isActionAllowed } from "../utilities";
import { useReconsets } from "../hooks";
import Loading from "../ui/Loading";
import { styles } from "../styles";

function getIsMatch(filter: string) {
  const isMatch = (reconset: ReconsetType) => {
    const re = new RegExp(escapeRegExp(filter), "i");
    return re.test(reconset.name) || re.test(reconset.displayName) || re.test(reconset.description);
  };
  return isMatch;
}

export default function Reconsets() {
  let [searchParams] = useSearchParams();
  let entityId = searchParams.get("entityId");
  let navigate = useNavigate();

  let [filter, setFilter] = React.useState("");
  const { data: reconsets, isLoading } = useReconsets(entityId);
  let [filteredReconsets, setFilteredReconsets] = React.useState<ReconsetType[]>([]);
  const theme = useMantineTheme();

  React.useEffect(() => {
    if (reconsets) {
      let filteredValues = reconsets.filter(getIsMatch(filter));
      setFilteredReconsets(filteredValues);
    }
  }, [reconsets, filter]);

  return (
    <div style={{ marginTop: theme.spacing.lg }}>
      <Title order={3}>Reconciliation</Title>
      <Grid align="center" gutter={"xs"} mb="xs">
        <Grid.Col span={3}>
          <TextInput
            placeholder="Search"
            onChange={(event) => {
              setFilter(event.target.value);
              let filteredValues = reconsets.filter(getIsMatch(event.target.value));
              setFilteredReconsets(filteredValues);
            }}
          />
        </Grid.Col>
        <Grid.Col span={1}>
          <Button
            color="teal"
            styles={() => ({
              root: {
                // margin: "5px",
              },
            })}
            aria-label="New"
            fullWidth
            component={Link}
            to={`/app/reconsets/new?entityId=${entityId}`}
          >
            New
          </Button>
        </Grid.Col>
      </Grid>

      {isLoading ? (
        <Grid align="center" gutter={"xs"} mb="xs" mt="lg">
          <Grid.Col span={3}>
            <Loading />
          </Grid.Col>
        </Grid>
      ) : (
        <>
          {filteredReconsets.length > 0 ? (
            <Grid align="center" gutter={"xs"} mb="xs">
              {filteredReconsets.map((reconset) => {
                return (
                  <Grid.Col span={3} key={reconset.id as unknown as string}>
                    <Card
                      component={Link}
                      to={`/app/reconsets/view?id=${reconset.id}&entityId=${entityId}`}
                      shadow="sm"
                      p="xs"
                      data-testid="reconset"
                    >
                      <Text fw={500}>{reconset.name}</Text>
                      <Text
                        size="sm"
                        style={{
                          color: theme.colors.gray[7],
                          lineHeight: 1.5,
                        }}
                      >
                        {reconset.description}
                      </Text>
                    </Card>
                  </Grid.Col>
                );
              })}
            </Grid>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: theme.spacing.lg,
              }}
            >
              <Text fw={500} style={styles.nodata} data-testid="nodata">
                No Reconsets
              </Text>
            </div>
          )}
        </>
      )}
    </div>
  );
}
